import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, Renderer2 } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';

import { ContainerComponent } from '../../container/container.component';
import { MenuMobileComponent } from '../menu-mobile/menu-mobile.component';
import { MenuDesktopComponent } from '../menu-desktop/menu-desktop.component';
import { filter } from 'rxjs';

@Component({
  selector: 'nav[navigation-bar]',
  imports: [CommonModule, RouterModule, ContainerComponent, MenuMobileComponent, MenuDesktopComponent],
  templateUrl: './navigation-bar.component.html',
  styleUrl: './navigation-bar.component.scss',
  host: {
    class: 'navbar w-100 d-block z-2',
    '[class.top-0]': '!isSpanish && !isRootRoute',
    '[class.top-32]': 'isSpanish || isRootRoute',
    '[class.position-absolute]':  'isSpanish || isRootRoute',
    '[class.expanded]': '!isMenuCollapsed'
  }
})
export class NavigationBarComponent implements OnInit {
  //Variables
  @Input() isWhiteNav: boolean = true;
  @Input() isSpanish!: boolean;

  isMenuCollapsed: boolean = true;
  isRootRoute = false;

  constructor(
    private router: Router,
    private renderer: Renderer2
  ) { }

  ngOnInit(): void {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        // console.log(event.urlAfterRedirects);
        if (event.urlAfterRedirects === '/' || event.url === '/es') {
          this.isRootRoute = true;
        } else {
          this.isRootRoute = false;
        }
      });
  }

  //Functions
  toggleMenu() {
    this.isMenuCollapsed = !this.isMenuCollapsed;
    this.menuState();
  }

  menuState() {
    if (this.isMenuCollapsed) {
      this.renderer.removeStyle(document.body, 'overflow');
    } else {
      this.renderer.setStyle(document.body, 'overflow', 'hidden');
    }
  }
}
